<div class="card card-nc esign_box ">
  <div class="navyCashHeading">
    Contact Us
  </div>
  <div class="row" style="font-size: 14px;">
    <div class="col-md-12">
      <div class="card card-nc subEnroll">
        <div class="card-body enroll">
          <div class="helpTitle">
            The activation link in your email is no longer valid. Please click
            <button (click)="startOver()">here</button> to start a new
            enrollment application.<br />
            <br />
            <b>Cardholder Phone Number</b><br />
            1-866-3NAVYCASH/1-866-362-8922<br />
            <br />
            <b>Additional Program Information</b><br />
            Visit
            <a href="http://www.fiscal.treasury.gov/stored-value-card"
              >www.fiscal.treasury.gov/stored-value-card</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
